import { Component } from '@angular/core';
import { ProviderClass } from '@finxone-platform/shared/sys-config-types';

@Component({
  selector: 'finxone-web-frontend-spacer-widget',
  template: ` <spacer class="d-flex" [ngStyle]="cssStyle"></spacer> `,
  standalone: false,
})
export class SpacerWidgetComponent {
  cssStyle: { height: string };

  constructor(private dataIn: ProviderClass<any>) {
    this.cssStyle = {
      height: `${this.dataIn?.attri?.css_config?.height ?? 15}${
        this.dataIn?.attri?.css_config?.heightUnit ?? 'px'
      }`,
    };
  }
}
